import ConfigView from "../ConfigView.vue";
import BlackList from "../Pages/BlackList.vue"
import BlackListEditor from "../Pages/BlackListEditor.vue"

const routes = [
  {
    path: '/travelbot',
    component: ConfigView,
    name: 'travelbot',
    children: [
      {
        path: 'black-list',
        name: 'travelbot-black-list',
        component: BlackList
      },
      {
        path: 'black-list/create',
        name: 'travelbot-black-list-create',
        component: BlackListEditor,
      },
      {
        path: 'black-list/:id/edit',
        name: 'travelbot-black-list-edit',
        component: BlackListEditor,
      },
    ]
  },
]

export default routes
